export default "__VITE_ASSET__DHxC_wrE__"